import { FC } from "react";
import {
  Flex,
  Box,
  Heading,
  Text,
  Image,
  Button,
  Link,
} from "@chakra-ui/react";
import { primaryColor } from "../../../utils/colors";
import { Outlet, useNavigate } from "react-router-dom";

const LoginLayout: FC = () => {
  const navigate = useNavigate();

  return (
    <Flex as="main" height="100vh">
      <Flex
        width="40%"
        bg="white"
        p={24}
        direction="column"
        justify="space-between"
        align="flex-start"
        shrink="0"
      >
        <Box marginBottom="16px">
          <Button
            variant="secondary"
            size="md"
            fontWeight="bold"
            onClick={() => navigate("/")}
          >
            Voltar à página incial
          </Button>
        </Box>
        <Flex
          width="100%"
          direction="column"
          align="flex-start"
          gap={16}
          flex="1"
          justify="center"
          marginTop="auto"
        >
          <Heading width="67%">
            <Image
              src="/images/sisan.png"
              alt="Sistema de Informação e Alerta Rápido para a Segurança Alimentar e Nutricional"
            />
          </Heading>
          <Outlet />
        </Flex>
        <Box marginTop="auto">
          <Link
            href="mailto:suporte@example.com"
            size="md"
            fontWeight="bold"
            color={primaryColor}
            textDecor="none"
          >
            Contactar suporte (suporte@example.com)
          </Link>
        </Box>
      </Flex>
      <Flex
        width="60%"
        bgImage="/images/login.png"
        bgSize="cover"
        bgPosition="center"
        bgRepeat="no-repeat"
        direction="column"
        paddingStart="53px"
        paddingEnd="53px"
        paddingBottom="96px"
        justifyContent="center"
      >
        <Flex marginTop="auto" justifyContent="space-between">
          <Text fontSize="14px" color="#fff">
            © 2024 SISAN - Todos os direitos reservados
          </Text>
          <Text fontSize="14px" color="#fff">
            v1.1
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default LoginLayout;
